import de from './de';
import en from './en';

const translations = { de, en };

export const getTranslation = (lang) => translations[lang] || translations.de;

export const supportedLanguages = [
  { code: 'de', label: 'DE', name: 'Deutsch' },
  { code: 'en', label: 'EN', name: 'English' },
];

export const defaultLanguage = 'de';

export default translations;
